import styled from '@emotion/styled/macro';
import { ClaimsBundleBadge } from '@enter/core';

export const ClaimBundleRow = styled.div`
    display: flex;
    padding-top: 16px;
    padding-bottom: 16px;
    width: 100%;
`;

export const ClaimsBundleBadgeWrapper = styled(ClaimsBundleBadge)`
    section {
        justify-content: flex-start;
    }

    section > div {
        margin: 10px 0;
    }
`;
